export const homeRoute = {
  path: "/",
  component: () => import("@/views/home/index.vue"),
};
